import { SleekButton } from '../../theme';

type Props = {
  /** The wheel is spinning — Skip is offered. */
  isSpinning: boolean;
  onSkip: () => void;
};

/** Sleek ready-step CTA: no Rip (partner Figma 2026-10-06 — the player
 *  swipes the pack), only "Skip" while the wheel spins. At rest the button
 *  keeps its slot, invisible, so the pack doesn't jump when it appears. */
export function SleekReadyCta({ isSpinning, onSkip }: Props) {
  return (
    <SleekButton
      name="RevealRipButton"
      onClick={onSkip}
      disabled={!isSpinning}
      aria-hidden={!isSpinning}
      tabIndex={isSpinning ? 0 : -1}
      className={'w-full ' + (isSpinning ? '' : 'invisible')}
    >
      Skip
    </SleekButton>
  );
}
